import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { watch as i, computed as n } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function f(u, e) {
  return i(u, (r) => {
    r !== void 0 && (e.value = r);
  }), n(() => u.value === void 0 ? e.value : u.value);
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/use-merged-state.js
// module id = 54
// module chunks = 41